import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { NavLink } from 'react-router-dom';

const menuItems = [
  { to: '/dashboard', icon: 'bar-chart-2', label: 'Dashboard' },
  { to: '/users', icon: 'users', label: 'Users' },
  { to: '/stores', icon: 'map-pin', label: 'Stores' },
  { to: '/posts/moderation', icon: 'shield', label: 'Post Moderation' },
  { to: '/import/stores', icon: 'upload', label: 'Store Import' },
];

function Sidebar() {
  useEffect(() => {
    feather.replace();
  });

  return (
    <nav
      className="bg-dark text-white position-fixed top-0 start-0 vh-100 d-flex flex-column"
      style={{ width: '250px', zIndex: 1030 }}
    >
      <div className="p-3 border-bottom border-secondary">
        <h5 className="mb-0 fw-bold">Cranova</h5>
        <small className="text-muted">Admin Panel</small>
      </div>

      <ul className="nav nav-pills flex-column mt-2 px-2 flex-grow-1">
        {menuItems.map((item) => (
          <li className="nav-item" key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                'nav-link text-white d-flex align-items-center gap-2 rounded' +
                (isActive ? ' bg-primary' : ' hover-bg')
              }
            >
              <i data-feather={item.icon} style={{ width: 18, height: 18 }}></i>
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="p-3 border-top border-secondary">
        <small className="text-muted">v0.1.0</small>
      </div>
    </nav>
  );
}

export default Sidebar;
